export default __webpack_public_path__ + "static/media/rob.793e0ad9.jpeg";